import { styled, Theme } from "@mui/material/styles";
import { colors } from "@zapalacorp/tokens";

export const ImageLogo = styled("img")(() => ({
  height: "48px",
  maxWidth: "215px",
}));

export const CompanyNameWrapper = styled("div")(() => ({
  "@media screen and (max-width: 475px)": {
    padding: "24px 16px",
    maxWidth: 250,
  },
}));

export const CompanyName = styled("span")(() => ({
  overflow: "hidden",
  color: colors.gray800,
  textOverflow: "ellipsis",
  display: "block",
  width: "100%",

  fontFamily: "Manrope",
  fontSize: 24,
  fontWeight: 700,
  lineHeight: "32px",
  textWrap: "nowrap",
}));

export const Steps = styled("div")(() => ({
  "@media screen and (max-width: 859px)": {
    display: "none",
  },
}));

interface IHeaderContainer {
  isHeaderInsideJobPage: boolean;
  theme?: Theme;
}

export const HeaderContainer = styled("header")(
  ({ isHeaderInsideJobPage, theme }: IHeaderContainer) => ({
    display: "flex",
    flexDirection: "column",
    margin: 0,
    padding: 0,
    backgroundColor: theme?.palette.secondary.main,
    zIndex: 1000,
    boxShadow: isHeaderInsideJobPage ? "0px 0px 6px 0px rgba(71, 84, 103, 0.20)" : "0",
  })
);

export const HeaderWrapper = styled("div")(() => ({
  alignItems: "center",
  display: "flex",
  flexDirection: "column",
  justifyContent: "space-between",

  position: "relative",
  paddingTop: "24px",
  paddingLeft: "32px",
  paddingRight: "32px",

  maxWidth: 1440,
  width: "100%",
  marginLeft: "auto",
  marginRight: "auto",
}));

export const HeaderContent = styled("div")(() => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  width: "100%",
}));

export const CompanyTitle = styled("div")(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  gap: "4px",
  justifyContent: "flex-start",
  width: "100%",
  maxWidth: 1440,
  marginLeft: "auto",
  marginRight: "auto",
  padding: "16px 16px 0",

  [theme.breakpoints.up("md")]: {
    padding: "24px 32px 0",
  },
}));

export const CustomerName = styled("span")(() => ({
  color: colors.gray800,
  fontFamily: "Manrope",
  fontSize: "24px",
  fontWeight: 500,
  lineHeight: "32px",
  textAlign: "left",
}));

export const StyledCustomerName = styled(CustomerName)(() => ({
  fontSize: "22px",
  lineHeight: "28px",
}));

export const GreetingText = styled("span")(() => ({
  color: colors.gray500,
  fontFamily: "Manrope",
  fontSize: "16px",
  fontWeight: 600,
  lineHeight: "24px",
  letterSpacing: "0.15px",
  height: "24px",
  textAlign: "left",
}));

export const AsideWrapper = styled("div")(() => ({
  display: "flex",
  alignContent: "center",
  justifyContent: "flex-end",
  width: "100%",
  maxWidth: "900px",

  "@media and (min-width: 860px)": {
    gap: "80px",
    justifyContent: "space-between",
  },
}));

export const HeaderMenusSection = styled("div")(() => ({
  display: "flex",
  flexDirection: "row",
  justifyContent: "space-between",
  gap: "0 80px",

  width: "fit-content",

  "@media screen and (max-width: 940px)": {
    gap: 0,
  },
}));
